/**
 * @description Checks whether the value provided is of type string
 *
 * @param {unknown} valueToCheck The value we are checking is a string
 * @returns {boolean} Type casting if the value is a string
 */
export var isString = function (valueToCheck) { return typeof valueToCheck === 'string'; };
//# sourceMappingURL=isString.js.map